import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild, ActivatedRoute } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { OpendialogLoginComponent } from 'app/components/dialog/open-dialog-login/opendialog-login.component';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';
import { DataService } from '../services/data/data.service';
import { UiService } from '../services/ui/ui.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
    private stateUrl: string;

    constructor(
        private authSrv: AuthService,
        private uiSrv: UiService,
        private router: Router,
        private jwtHelperSrv: JwtHelperService,
        private route: ActivatedRoute,
        private dataService: DataService,
        private dialog: MatDialog
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        this.stateUrl = state.url;
        // No token
        if (!this.jwtHelperSrv.tokenGetter()) {
            this.dataService.tabHome$.next('home');
            this.dialog.open(OpendialogLoginComponent, {
                data: { url: state.url }
            });
            this.logout();
            return false;
        }


        // token valid and up to date
        if (this.authSrv.isAuth()) {
            this.dataService.titleWelcome$.next(`Bienvenue ${this.authSrv.getDecodedToken().middle_name}`);
            return true;
        }



        // Token exists but outdated
        return this.refreshToken();
    }

    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this.canActivate(route, state);
    }



    private needResetPwd(): boolean {
        const decodedToken = this.authSrv.getDecodedToken();

        if (decodedToken && decodedToken.upd_pwd_req) {
            return true;
        }

        return false;
    }


    private refreshToken(): Observable<boolean> {
        this.uiSrv.routeLoadingStateChanged.next(true);

        return this.authSrv.refreshToken().pipe(
            map(() => {
                this.uiSrv.routeLoadingStateChanged.next(false);
                return true;
            }),
            catchError(error => {
                this.uiSrv.routeLoadingStateChanged.next(false);
                this.logout();
                return of(error);
            })
        );
    }

    private logout(): void {
        this.authSrv.logout(this.stateUrl);
        this.authSrv.isAuth();
    }
}
